module.exports = __webpack_public_path__ + "img/3.a907cd71.jpg";